import { GuideInputText } from 'components/admin/input/GuideInputText';
import { ActionButton } from 'elements/minute/sidebar/sidebarComponents/atomic/ActionButton';
import { useEffect, useState } from 'react';
import { apiUploadImportFile } from 'static/api/directApi';
import styled from 'styled-components/macro';

export function prepareFile(file: Blob, userId: string): FormData {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('targetUserId', userId);
    return formData;
}

interface Props {
    className?: string;
    style?: React.CSSProperties;
    onFileSelected?: () => void;
    onFileUploaded?: (guideId: string) => void;
}

export const FileForm = (props: Props): JSX.Element => {
    const [file, setFile] = useState<File>();
    const [userId, setUserId] = useState<string>('');

    useEffect(() => {
        if (!file) {
            return;
        }
        const formData = prepareFile(file, userId);
        apiUploadImportFile(formData).then((res) => {
            props.onFileUploaded?.(res?.['data']?.['guideId'] as string);
        });
    }, [file]);

    return (
        <S_FileForm className={props.className} style={props.style}>
            <GuideInputText label="User id" value={userId} onChange={setUserId} />
            <label className="upload">
                <input
                    id="fileUpload"
                    type="file"
                    accept="kmz"
                    onChange={(e) => {
                        setFile(e.target['files'][0]);
                        props?.onFileSelected();
                    }}
                />
                <S_ActionButton text={'Select kmz file'} icon={{ iconName: 'upload' }} />
            </label>
        </S_FileForm>
    );
};

const S_FileForm = styled.div``;

const S_ActionButton = styled(ActionButton)``;
